"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var stickyTeasers = function () {
    var section = document.querySelector('.c-stickyTeasersSec');
    var wrapper = section === null || section === void 0 ? void 0 : section.querySelector('.c-stickyTeasersSec_wrapper');
    if (!section || !wrapper)
        return;
    var rows = section.querySelectorAll('.c-stickyTeasersSec_row');
    var lastActiveRow = 1;
    if ((0, helpers_1.isTabletRes)()) {
        rows.forEach(function (row) {
            row.classList.add('js-lazy', 'a-fadeInUp');
        });
    }
    var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
            window.addEventListener('scroll', function () {
                if (!(0, helpers_1.isTabletRes)()) {
                    var windowScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var viewportHeight = window.innerHeight;
                    if (windowScroll >= section.offsetTop + wrapper.offsetTop - wrapper.clientHeight &&
                        windowScroll <= section.offsetTop + wrapper.offsetTop + wrapper.clientHeight) {
                        var activeRow = Math.ceil((windowScroll - (section.offsetTop + wrapper.offsetTop)) / viewportHeight + 0.5);
                        if (activeRow != lastActiveRow && activeRow > 0 && activeRow <= rows.length) {
                            rows[lastActiveRow - 1].classList.remove('-active');
                            lastActiveRow = activeRow;
                            rows[activeRow - 1].classList.add('-active');
                        }
                    }
                }
            });
        }
    });
    observer.observe(wrapper);
};
stickyTeasers();
